import {booleanAttribute, Component, input} from '@angular/core';

/**
 * Row of an `app-data-list`. Put it on an anchor to make the whole row a link
 * (`<a app-data-row [routerLink]="...">`), so no separate edit or view icons are needed.
 * `header` renders the column titles, `tone` colors the row (error = light red), `chevron` adds the arrow column.
 */
@Component({
    selector: 'app-data-row, [app-data-row]',
    templateUrl: './data-row.component.html',
    styleUrl: './data-row.component.scss',
    host: {
        '[attr.role]': 'header() ? "rowheader" : "row"',
        '[class.header]': 'header()',
        '[class.dense]': 'dense()',
        '[class]': 'tone() ? "tone-" + tone() : ""'
    }
})
export class DataRowComponent {
    readonly header = input(false, {transform: booleanAttribute});
    readonly tone = input<'error' | 'ok' | 'warn' | 'muted' | null>(null);
    readonly chevron = input(false, {transform: booleanAttribute});
    readonly dense = input(false, {transform: booleanAttribute});
}
